<template>
  <v-dialog v-model="dialog" persistent width="60%">
    <v-form ref="payoutForm">
      <v-card flat>
        <v-card-title>
          <h3>{{ $t('revenue.pay.title') }}</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-layout row wrap class="pa-3">
          <v-flex xs12>
            <div v-if="type == DEFINES.MONETIZATION.PAYOUT.CLIENT_PAYOUT">
              <v-text-field
                label="Amount to be Paid"
                :rules="[rules.required, rules.floating_number]"
                v-model.number="localUnpaidAmount"
                :prefix="currency_symbol"
                color="primary"
                :disabled="showStatus"
              >
              </v-text-field>
              <v-alert
                  :value="localUnpaidAmount > 0"
                  border="right"
                  color="blue-grey"
                >
                Will detect the amount from company's unpaid revenue
              </v-alert>
            </div>
            <div v-if="type == DEFINES.MONETIZATION.PAYOUT.ADJUSTMENT">
              <v-text-field
                label="Amount to be Adjusted"
                :rules="[rules.required]"
                v-model.number="localPayoutAmount"
                :prefix="currency_symbol"
                color="primary"
              >
              </v-text-field>
              <v-alert
                :value="showNegativeAmountMessage"
                border="right"
                color="blue-grey"

              >
                A negative value is in favor of the client (Org), meaning it’s added to the client unpaid revenue
              </v-alert>
              <v-alert
                :value="showPositiveAmountMessage"
                border="right"
                color="blue-grey"
                >
                A positive value is in favor of MEW, meaning it’s deducted from the client unpaid revenue
              </v-alert>
            </div>
          </v-flex>
          <v-flex xs12 v-if="showStatus">
            <v-select
                v-model="localStatus"
                :items="statusNames"
                item-text="name"
                item-value="value"
                :label="$t('payout.label.select.status')"
                return-object
                color="primary"
              ></v-select>
          </v-flex>

          <v-flex xs12>
            <v-text-field
              label="Client Note"
              :rules="[rules.required]"
              v-model="localClientNote"
              color="primary"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Admin Note"
              :rules="[rules.required]"
              v-model="localAdminNote"
              color="primary"
            >
            </v-text-field>
          </v-flex>
        </v-layout>

        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn dark @click.stop="$emit('onCancel')" color="grey">{{
            $t('rms.button.cancel')
          }}</v-btn>
          <v-btn
            dark
            @click.stop="onPay"
            color="primary"
            >{{ status == DEFINES.MONETIZATION.PAYOUT_STATUS_NAMES.COMPLETED?$t("pay_now.title"):btnText }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import {currencySymbol} from '@/mixins/monetization';
import rules from '@/validation';
import i18n from '@/i18n';
import DEFINES from '@/defines';

export default {
  name: 'ConfirmPayout',
  data() {
    return {
      rules,
      showPositiveAmountMessage: false,
      showNegativeAmountMessage: false,
      statusNames: [
        {
          name: i18n.t('payout.type.all'),
          value: null,
        },
        {
          name: i18n.t('screener.payout_status.requested'),
          value: DEFINES.MONETIZATION.PAYOUT_STATUS_NAMES.REQUESTED,
        },
        {
          name: i18n.t('screener.payout_status.in_process'),
          value: DEFINES.MONETIZATION.PAYOUT_STATUS_NAMES.IN_PROCESS,
        },
        {
          name: i18n.t('screener.payout_status.rejected'),
          value: DEFINES.MONETIZATION.PAYOUT_STATUS_NAMES.REJECTED,
        },
        {
          name: i18n.t('screener.payout_status.completed'),
          value: DEFINES.MONETIZATION.PAYOUT_STATUS_NAMES.COMPLETED,
        },
      ],
    };
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    client_note: {type: String, default: null},
    unpaid_amount: {default: null},
    payout_amount: {default:null},
    admin_note: {type: String, default: null},
    currency_symbol: {
      type: String,
    },
    type:{
      type: Number, default: null
    },
    status:{
      type: Number, default: null
    },
    btnText:{
      type: String, default: i18n.t('pay_now.title')
    },
    showStatus :{
      type: Boolean, default: false
    }
  },
  mixins: [currencySymbol],
  watch:{
    localPayoutAmount(){
      if (this.localPayoutAmount > 0) {
        this.showPositiveAmountMessage = true;
        this.showNegativeAmountMessage = false;
      }

      if (this.localPayoutAmount < 0) {
        this.showNegativeAmountMessage = true;
        this.showPositiveAmountMessage = false;
      }

      if(!this.localPayoutAmount){
        this.showNegativeAmountMessage = false;
        this.showPositiveAmountMessage = false;
      }
    }
  },
  computed: {
    localUnpaidAmount: {
      get: function() {
        return this.unpaid_amount;
      },
      set: function(value) {
        this.$emit('update:unpaid_amount', value);
      },
    },

    localPayoutAmount: {
      get: function() {
        return this.payout_amount;
      },
      set: function(value) {
        this.$emit('update:payout_amount', value);
      },
    },

    localClientNote: {
      get: function() {
        return this.client_note;
      },
      set: function(value) {
        this.$emit('update:client_note', value);
      },
    },

    localAdminNote: {
      get: function() {
        return this.admin_note;
      },
      set: function(value) {
        this.$emit('update:admin_note', value);
      },
    },

    localStatus: {
      get: function() {
        return this.status;
      },
      set: function(value) {
        console.log(value)
        this.$emit('update:status', value.value);
      },
    },
  },

  methods: {
    onPay() {
      if (!this.$refs.payoutForm.validate()) {
        return false;
      }

      this.$emit('onConfirm');
    },
  },
};
</script>
